import { Alert, Container } from '@mui/material';
import { Redirect } from 'react-router-dom';
import AiReviewReplayPresentation from '../components/assessment/AiReviewReplayPresentation';
import { useAccessInfo } from '../contexts/AccessTokenProvider';
import { Securables } from '../Enums';
import {
  CAPTURE_REPLAY_ORGANIZATION_IDS,
  isNorthstarCaptureReplayOrganization,
} from '../Environment';
import AiReviewReplayService, {
  aiReviewReplayFingerprint,
  AiReviewReplayFixture,
  AI_REVIEW_REPLAY_VERSION,
} from '../services/AiReviewReplayService';

export const isCaptureSafeAiReviewReplay = (fixture: AiReviewReplayFixture): boolean =>
  fixture.Version === AI_REVIEW_REPLAY_VERSION
  && fixture.IsSynthetic === true
  && fixture.ReadOnly === true
  && JSON.stringify(fixture) === aiReviewReplayFingerprint();

const AiReviewReplayPage = () => {
  const { accessInfo } = useAccessInfo();
  try {
    const fixture = new AiReviewReplayService().Get(
      accessInfo?.selectedOrganizationId ?? '',
      accessInfo?.selectedOrganizationName ?? '',
    );
    if (!isCaptureSafeAiReviewReplay(fixture))
      throw new Error('Unsafe AI replay fixture.');
    return <AiReviewReplayPresentation fixture={fixture} />;
  } catch {
    return <Container maxWidth="md" sx={{ py: 4 }}><Alert severity="warning">AI review replay is unavailable for this organization.</Alert></Container>;
  }
};

export const AiReviewReplayRoute = () => {
  const { accessInfo, hasOneOfRoles } = useAccessInfo();
  const authorized = hasOneOfRoles([Securables.organization_administrator, Securables.synergist_admin], true);
  const allowed = isNorthstarCaptureReplayOrganization(
    accessInfo?.selectedOrganizationId ?? '',
    accessInfo?.selectedOrganizationName ?? '',
    CAPTURE_REPLAY_ORGANIZATION_IDS,
  );
  return authorized && allowed ? <AiReviewReplayPage /> : <Redirect to="/" />;
};

export default AiReviewReplayPage;
